export default function ProgressBar({ value, max, color = "blue", showLabel = true, size = "md" }) {
  const pct = max > 0 ? Math.min(100, (value / max) * 100) : 0;
  const colorMap = {
    blue:   "bg-primary-500",
    green:  "bg-secondary-500",
    red:    "bg-red-500",
    yellow: "bg-yellow-500",
    purple: "bg-purple-500",
    orange: "bg-orange-500",
  };
  const heights = { sm: "h-1.5", md: "h-2.5", lg: "h-4" };
  const bar = colorMap[color] || colorMap.blue;
  const h   = heights[size]  || heights.md;

  return (
    <div className="w-full">
      <div className={`w-full bg-gray-200 dark:bg-gray-700 rounded-full ${h} overflow-hidden`}>
        <div
          className={`${bar} ${h} rounded-full transition-all duration-500`}
          style={{ width: `${pct}%` }}
        />
      </div>
      {showLabel && (
        <div className="flex justify-between mt-1 text-xs text-gray-500 dark:text-gray-400">
          <span>{pct.toFixed(0)}%</span>
          <span>
            {value.toLocaleString("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 0 })}
            {" / "}
            {max.toLocaleString("en-US",  { style: "currency", currency: "USD", maximumFractionDigits: 0 })}
          </span>
        </div>
      )}
    </div>
  );
}
